import { MerchantInfo } from "@/domain/types";

export function getPrimaryColor(merchant?: MerchantInfo | null): string {
  if (!merchant) return "primary";
  if (!merchant.branding?.color) return "#0A67A3";
  return merchant.branding.color;
}
